<template>
  <div class="r-null">
      <img src="../assets/images/null.png" :style="imgStyle" alt="">
      <div class="fontStyle" :style="titleStyle">{{title}}</div>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },
  props:{
      title:String,
      imgStyle:String,
      titleStyle:String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-null{
    img{
        direction: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/r-null.vue